var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.THGHeader),_c('div',{staticClass:"container is-fluid"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }